import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { I as h } from "../chunks/index.ed48ee81.js";
import { g as L } from "../chunks/generate-random-id.f7e64105.js";
import { m as M } from "../chunks/make-refs.cb0b9b76.js";
import { forwardRef as O, useEffect as S, useRef as P, useState as y } from "react";
import { c as Q, s } from "../chunks/common.47956ba6.js";
const _ = O(
  ({
    "aria-label": C,
    a11yLabel: u,
    a11yTitle: k,
    children: N,
    className: R,
    content: g,
    heading: n,
    isSelected: t = !1,
    label: z,
    labelElement: B = "strong",
    leadingIcon: m,
    onToggle: c,
    size: I = "small",
    title: $,
    ...v
  }, w) => {
    const { $el: x, $header: j } = M(w, ["$el", "$header"]), E = (r = !1) => {
      const o = P(null), [d, b] = y(r), [G, J] = y(0);
      S(() => {
        var a;
        J(
          d && ((a = o.current) == null ? void 0 : a.scrollHeight) || 0
        );
      }, [d]);
      const K = () => {
        b((a) => !a);
      };
      return {
        bodyBlockSize: G,
        bodyRef: o,
        isSelected: d,
        randomId: L("collapse-content"),
        setIsCollapseSelected: b,
        toggleCollapse: K
      };
    }, {
      bodyBlockSize: H,
      bodyRef: q,
      isSelected: l,
      randomId: p,
      setIsCollapseSelected: f,
      toggleCollapse: A
    } = E(t), D = (r) => {
      const o = !l;
      A(), c == null || c(r, o);
    };
    S(() => {
      f(t);
    }, [t, f]);
    const F = Q({
      className: R,
      isSelected: l,
      size: I
    });
    return /* @__PURE__ */ i("div", { className: F, ref: x, ...v, children: [
      /* @__PURE__ */ i(
        "button",
        {
          "aria-controls": p,
          "aria-expanded": l,
          "aria-label": C || u,
          className: s.header,
          onClick: D,
          ref: j,
          title: $ || k,
          type: "button",
          children: [
            m && /* @__PURE__ */ e(h, { icon: m, method: "image" }),
            /* @__PURE__ */ e(B, { className: s.label, children: z }),
            /* @__PURE__ */ e(h, { icon: "24/symbol/chevron-down" })
          ]
        }
      ),
      /* @__PURE__ */ i(
        "div",
        {
          "aria-hidden": !l,
          className: s.body,
          id: p,
          ref: q,
          style: { blockSize: `${H}px` },
          children: [
            n && /* @__PURE__ */ e("strong", { className: s.heading, children: n }),
            /* @__PURE__ */ e("div", { className: s.content, children: N || g })
          ]
        }
      )
    ] });
  }
);
export {
  _ as Collapse
};
//# sourceMappingURL=Collapse.js.map
